import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewVerbalExponent extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText() {

        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        } else {
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);

        let text = this._template ? this._template.text : "";

        const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
        for (const i in values) {
            if (values.hasOwnProperty(i)) {
                if (typeof values[i] === "string"){
                    values[i] = values[i].replace("²", "");//strip out exponent superscript characters
                    values[i] = values[i].replace("³", "");
                }
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
            }
        }

        const match = text.match(/\. [a-z]/g);
        if (match) {
            for (let i = 0; i < match.length; ++i) {
                const s = match[i];
                text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
            }
        }

        return text;
    }

    isCorrect() {
        return this._inputValue.value === this._question.answer.value;
    }

    filterTemplate(x) {
        return true;
    }
}